import React, { useEffect, useState } from 'react';
import { FilterList, Close, Add, DeleteForever, LocationOn } from '@mui/icons-material';
import { Badge, Button, Popover, Typography, Box, Grid, FormControl, InputLabel, Select, MenuItem, TextField,IconButton,RadioGroup,FormControlLabel,Radio,FormLabel,Alert,Divider,Chip,Autocomplete,Slider} from '@mui/material';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FormProvider, useForm, Controller, useFieldArray } from 'react-hook-form';
import dayjs from 'dayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers';
// import { CrudServices } from '../../../MasterService/CrudServices';

// Sample Geo Polygon Data
const sampleGeoPolygons = [
  {
    id: 'mumbai_south',
    name: 'South Mumbai',
    description: 'Covers Colaba, Fort, Churchgate, Marine Drive',
    coordinates: [
      [72.8124, 18.9067], [72.8200, 18.9220], [72.8250, 18.9400], 
      [72.8180, 18.9450], [72.8090, 18.9300], [72.8124, 18.9067]
    ],
    area: '25 sq km',
    estimatedUsers: '50,000'
  },
  {
    id: 'mumbai_bandra',
    name: 'Bandra West',
    description: 'Covers Bandra West, Khar West, Santa Cruz West',
    coordinates: [
      [72.8200, 19.0500], [72.8350, 19.0600], [72.8400, 19.0750],
      [72.8280, 19.0800], [72.8150, 19.0650], [72.8200, 19.0500]
    ],
    area: '18 sq km',
    estimatedUsers: '75,000'
  },
  {
    id: 'delhi_cp',
    name: 'Central Delhi',
    description: 'Covers Connaught Place, Karol Bagh, Paharganj',
    coordinates: [
      [77.2000, 28.6200], [77.2200, 28.6300], [77.2250, 28.6450],
      [77.2100, 28.6500], [77.1950, 28.6350], [77.2000, 28.6200]
    ],
    area: '35 sq km',
    estimatedUsers: '120,000'
  },
  {
    id: 'bangalore_koramangala',
    name: 'Koramangala & BTM Layout',
    description: 'Tech hub area covering Koramangala and BTM Layout',
    coordinates: [
      [77.6100, 12.9200], [77.6300, 12.9250], [77.6350, 12.9400],
      [77.6200, 12.9450], [77.6050, 12.9350], [77.6100, 12.9200]
    ],
    area: '22 sq km',
    estimatedUsers: '85,000'
  },
  {
    id: 'pune_hinjewadi',
    name: 'Hinjewadi IT Park',
    description: 'IT corridor including Hinjewadi, Wakad, Baner',
    coordinates: [
      [73.7000, 18.5900], [73.7200, 18.6000], [73.7300, 18.6150],
      [73.7150, 18.6200], [73.6950, 18.6050], [73.7000, 18.5900]
    ],
    area: '28 sq km',
    estimatedUsers: '95,000'
  },
  {
    id: 'hyderabad_hitec',
    name: 'HITEC City',
    description: 'Financial district and HITEC City area',
    coordinates: [
      [78.3700, 17.4300], [78.3900, 17.4350], [78.3950, 17.4500],
      [78.3800, 17.4550], [78.3650, 17.4450], [78.3700, 17.4300]
    ],
    area: '30 sq km',
    estimatedUsers: '110,000'
  },
  {
    id: 'chennai_omr',
    name: 'OMR Corridor',
    description: 'Old Mahabalipuram Road IT corridor',
    coordinates: [
      [80.2100, 12.8900], [80.2300, 12.8950], [80.2400, 12.9100],
      [80.2250, 12.9150], [80.2050, 12.9050], [80.2100, 12.8900]
    ],
    area: '45 sq km',
    estimatedUsers: '130,000'
  },
  {
    id: 'gurgaon_cyber_city',
    name: 'Cyber City Gurgaon',
    description: 'DLF Cyber City and surrounding corporate areas',
    coordinates: [
      [77.0700, 28.4950], [77.0900, 28.5000], [77.0950, 28.5150],
      [77.0800, 28.5200], [77.0650, 28.5100], [77.0700, 28.4950]
    ],
    area: '20 sq km',
    estimatedUsers: '80,000'
  }
];

const AudienceFilter = ({ 
  filterableColumns, 
  onApplyFilter, 
  externalClear = false,
  defaultFilterCount = 1,
  defaultFilterOptions,
  enableLocationFilters = false,
  enableGeoFilters= true,
  defaultLocationFilters = {
    locationFilter: 'radius',
    centerCoordinates: { lat: '', lng: '' },
    radius: '',
    polygon: [],
    selectedPolygons: []
  },
  audienceType
}) => {
  const filterFormMethod = useForm({
    mode: "onChange",
    defaultValues: {
      filterOption: defaultFilterOptions?.length > 0 ? defaultFilterOptions : Array(defaultFilterCount).fill().map(() => ({ 
        fieldName: '', 
        operator: 'contains', 
        value: null 
      })),
      locationFilters: defaultLocationFilters
    }
  });

  const { control, handleSubmit, reset, setValue, getValues, watch } = filterFormMethod;
  const [anchorEl, setAnchorEl] = useState(null);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "filterOption"
  });

  useEffect(() => {
    if (externalClear) {
      reset({
        filterOption: [{ 
          fieldName: '', 
          operator: 'contains', 
          value: null 
        }],
        locationFilters: defaultLocationFilters
      });
    }
  }, [externalClear, reset, defaultLocationFilters]);

  const filterOption = watch('filterOption');
  const locationFilters = watch('locationFilters');

  // const activeBasicFilters = filterOption.filter(
  //   row => row.fieldName && row.value
  // ).length;

  const activeBasicFilters = filterOption.filter(option => {
  const hasFieldName = option.fieldName && option.fieldName.trim() !== '';
  const hasOperator = option.operator && option.operator.trim() !== '';
  
  let hasValidValue = false;
  if (option.value !== null && option.value !== undefined) {
      if (typeof option.value === 'string') {
          hasValidValue = option.value.trim() !== '';
      } else if (Array.isArray(option.value)) {
          hasValidValue = option.value.length > 0;
      } else {
          hasValidValue = true;
      }
  }
  
  return hasFieldName && hasOperator && hasValidValue;
}).length;

  const activeLocationFilters = enableLocationFilters && (
    (locationFilters.locationFilter === 'radius' && 
     locationFilters.centerCoordinates.lat && 
     locationFilters.centerCoordinates.lng && 
     locationFilters.radius) ||
    (locationFilters.locationFilter === 'polygon' && 
     locationFilters.selectedPolygons && locationFilters.selectedPolygons.length > 0)
  ) ? 1 : 0;

  const activeBadgeContent = activeBasicFilters + activeLocationFilters;
  const [activeFilterCount,setActiveFilterCount] = useState(activeBadgeContent);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setActiveFilterCount(activeBadgeContent);
  };

  // const handleClose = () => {
  //   setAnchorEl(null);
  //   if(activeBadgeContent > 0){
  //     onApplyFilter(getValues());
  //   }else if(activeBadgeContent === 0){
  //     if(activeFilterCount > 0){
  //       setActiveFilterCount(0);
  //       onApplyFilter({
  //         filterOption: [],
  //         locationFilters:{}
  //       })
  //     }
  //   }
  // };
  
  const handleClose = () => {
    setAnchorEl(null);
    
    const currentData = getValues();
    console.log("currentData:",currentData);
    
    // Filter out invalid filter options
    const validFilterOptions = currentData.filterOption.filter(option => {
        const hasFieldName = option.fieldName && option.fieldName.trim() !== '';
        const hasOperator = option.operator && option.operator.trim() !== '';
        
        let hasValidValue = false;
        if (option.value !== null && option.value !== undefined) {
            if (typeof option.value === 'string') {
                hasValidValue = option.value.trim() !== '';
            } else if (Array.isArray(option.value)) {
                hasValidValue = option.value.length > 0;
            } else {
                hasValidValue = true;
            }
        }
        
        return hasFieldName && hasOperator && hasValidValue;
    });
    
    const totalValidFilters = validFilterOptions.length;
    const hasValidLocationFilter = enableLocationFilters && (
        (currentData.locationFilters.locationFilter === 'radius' && 
         currentData.locationFilters.centerCoordinates.lat && 
         currentData.locationFilters.centerCoordinates.lng && 
         currentData.locationFilters.radius) ||
        (currentData.locationFilters.locationFilter === 'polygon' && 
         currentData.locationFilters.selectedPolygons && currentData.locationFilters.selectedPolygons.length > 0)
    );
    
    const totalActiveFilters = totalValidFilters + (hasValidLocationFilter ? 1 : 0);
    
    if(totalActiveFilters > 0){
        onApplyFilter({
            ...currentData,
            filterOption: validFilterOptions // Only send valid filters
        });
    } else if(totalActiveFilters === 0){
        if(activeFilterCount > 0){
            setActiveFilterCount(0);
            onApplyFilter({
                filterOption: [],
                locationFilters: {}
            });
        }
    }
};
  const onRemoveAllFIlters = () =>{
    onApplyFilter({
      filterOption: [],
      locationFilters:{}
    });
  }
  const openFilterForm = Boolean(anchorEl);

  const getAvailableColumns = (currentIndex) => {
    const selectedColumns = filterOption
      .filter((_, index) => index !== currentIndex)
      .map(option => option.fieldName)
      .filter(Boolean);

    return filterableColumns.filter(column => 
      !selectedColumns.includes(column.key)
    );
  };

  // const handleColumnChange = (e, index, columnField) => {
  //   const selectedColumn = filterableColumns.find(col => col.key === e.target.value);
    
  //   setValue(`filterOption.${index}.value`, null);
    
  //   if (selectedColumn?.type === 'date') {
  //     setValue(`filterOption.${index}.operator`, 'equals');
  //   } else if(selectedColumn?.type === 'email'){
  //     setValue(`filterOption.${index}.operator`, 'equals');
  //   } else if(selectedColumn?.type === 'select'){
  //     setValue(`filterOption.${index}.operator`, 'equals');
  //   } else if(selectedColumn?.type === 'range'){
  //     setValue(`filterOption.${index}.operator`, 'between');
  //   } else if(selectedColumn?.type === 'multiselect'){
  //     setValue(`filterOption.${index}.operator`, 'in');
  //   } else if(selectedColumn?.type === 'number'){
  //     setValue(`filterOption.${index}.operator`, 'equals');
  //   } else {
  //     setValue(`filterOption.${index}.operator`, 'contains');
  //   }
    
  //   columnField.onChange(e);
  // };
  const handleColumnChange = (e, index, columnField) => {
    const selectedColumn = filterableColumns.find(col => col.key === e.target.value);
    
    // Set default value for range type to its defaultValue
    if (selectedColumn?.type === 'range') {
      setValue(`filterOption.${index}.value`, selectedColumn.defaultValue);
      setValue(`filterOption.${index}.operator`, 'between');
    } else {
      setValue(`filterOption.${index}.value`, null);
      
      if (selectedColumn?.type === 'date') {
        setValue(`filterOption.${index}.operator`, 'equals');
      } else if(selectedColumn?.type === 'email'){
        setValue(`filterOption.${index}.operator`, 'equals');
      } else if(selectedColumn?.type === 'select'){
        setValue(`filterOption.${index}.operator`, 'equals');
      } else if(selectedColumn?.type === 'multiselect'){
        setValue(`filterOption.${index}.operator`, 'in');
      } else if(selectedColumn?.type === 'number'){
        setValue(`filterOption.${index}.operator`, 'equals');
      } else {
        setValue(`filterOption.${index}.operator`, 'contains');
      }
    }
    
    columnField.onChange(e);
  };

  const renderValueField = (field, index) => {
    const selectedColumn = filterableColumns.find(
      col => col.key === filterOption[index]?.fieldName
    );
    const currentOperator = filterOption[index]?.operator;
  
    switch(selectedColumn?.type) {
      case 'range':
        return (
          <Box sx={{ width: '100%', px: 2, py: 1 }}>
            <Typography variant="caption" sx={{ fontSize: '0.7rem', color: 'text.secondary', mb: 1, display: 'block' }}>
              {selectedColumn.label}: {field.value ? `${field.value[0]} - ${field.value[1]} years` : `${selectedColumn.defaultValue[0]} - ${selectedColumn.defaultValue[1]} years`}
            </Typography>
            <Slider
              {...field}
              value={field.value || selectedColumn.defaultValue}
              onChange={(event, newValue) => {
                field.onChange(newValue);
              }}
              valueLabelDisplay="auto"
              min={selectedColumn.min}
              max={selectedColumn.max}
              marks={selectedColumn.marks}
              sx={{
                '& .MuiSlider-thumb': {
                  height: 16,
                  width: 16,
                },
                '& .MuiSlider-valueLabel': {
                  fontSize: '0.7rem'
                },
                '& .MuiSlider-markLabel': {
                  fontSize: '0.6rem'
                }
              }}
            />
          </Box>
        );

      case 'date':
        if (currentOperator === 'between') {
          return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
                <DesktopDatePicker
                  label="Start Date"
                  value={field.value ? dayjs(field.value) : null}
                  onChange={(newValue) => {
                    field.onChange(newValue ? dayjs(newValue).endOf('day').toISOString() : null);
                  }}
                  format="DD-MM-YYYY"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: 'small',
                      variant: 'standard',
                      InputProps: { style: { height: '1.6rem', fontSize: '0.75rem' }},
                      InputLabelProps: { style: { fontSize: '0.75em' }}
                    }
                  }}
                />
                <DesktopDatePicker
                  label="End Date"
                  value={filterOption[index]?.endValue ? dayjs(filterOption[index]?.endValue) : null}
                  onChange={(newValue) => {
                    setValue(`filterOption.${index}.endValue`, newValue ? dayjs(newValue).endOf('day').toISOString() : null);
                  }}
                  format="DD-MM-YYYY"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: 'small',
                      variant: 'standard',
                      InputProps: { style: { height: '1.6rem', fontSize: '0.75rem' }},
                      InputLabelProps: { style: { fontSize: '0.75em' }}
                    }
                  }}
                />
              </Box>
            </LocalizationProvider>
          );
        }
        
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
              label={selectedColumn.label}
              value={field.value ? dayjs(field.value) : null}
              onChange={(newValue) => {
                field.onChange(newValue ? dayjs(newValue).endOf('day').toISOString() : null);
              }}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: 'small',
                  variant: 'standard',
                  InputProps: { style: { height: '1.6rem', fontSize: '0.75rem' }},
                  InputLabelProps: { style: { fontSize: '0.75em' }}
                }
              }}
            />
          </LocalizationProvider>
        );
      
      case 'multiselect':
        return (
          <Autocomplete
            {...field}
            multiple
            size="small"
            options={selectedColumn.options || []}
            getOptionLabel={(option) => option.label || option}
            value={field.value || []}
            onChange={(event, newValue) => {
              field.onChange(newValue);
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option.label || option}
                  size="small"
                  {...getTagProps({ index })}
                  sx={{ fontSize: '0.65rem', height: '20px' }}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label={selectedColumn.label}
                InputProps={{
                  ...params.InputProps,
                  style: {
                    fontSize: '0.75rem',
                    minHeight: '1.6rem'
                  }
                }}
                InputLabelProps={{
                  style: {
                    fontSize: '0.75em'
                  }
                }}
              />
            )}
            sx={{ width: '100%' }}
          />
        );
      
      case 'select':
        return (
          <FormControl variant='standard' sx={{ width:'100%' }} size="small">
            <InputLabel id={`select-label-${index}`} sx={{fontSize:'.75em', lineHeight:'2em'}}>
              {selectedColumn.label}
            </InputLabel>
            <Select
              {...field}
              labelId={`select-label-${index}`}
              value={field.value || ''}
              onChange={(e) => {
                field.onChange(e);
              }}
              sx={{
                minHeight: '0px',
                height: '1.6rem',
                fontSize: '0.75rem',
                fontWeight: '600',
                textTransform:'capitalize'
              }}
            >
              {selectedColumn.options.map(option => (
                <MenuItem key={option.value} value={option.value} sx={{fontSize:'0.75rem'}}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      
      case 'number':
        return (
          <TextField 
            {...field} 
            type="number"
            size='small'
            variant='standard'
            label={selectedColumn.placeholder || 'Value'}
            placeholder={selectedColumn.placeholder}
            InputProps={{
              inputProps: {
                style: {
                  height: '1.2rem',     
                  fontSize: '0.75rem',                     
                },
              },
            }}
            InputLabelProps={{
                style: {
                    fontSize: '0.75em'
                }
            }}    
          />
        );
      
      case 'boolean':
        return (
          <FormControl variant='standard' sx={{ width:'100%' }} size="small">
            <InputLabel id={`boolean-label-${index}`} sx={{fontSize:'.75em', lineHeight:'2em'}}>
              {selectedColumn.label}
            </InputLabel>
            <Select
              {...field}
              labelId={`boolean-label-${index}`}
              value={field.value || ''}
              onChange={(e) => {
                field.onChange(e);
              }}
              sx={{
                minHeight: '0px',
                height: '1.6rem',
                fontSize: '0.75rem',
                fontWeight: '600',
                textTransform:'capitalize'
              }}
            >
              <MenuItem value="true" sx={{fontSize:'.75rem'}}>Yes</MenuItem>
              <MenuItem value="false" sx={{fontSize:'.75rem'}}>No</MenuItem>
            </Select>
          </FormControl>
        );
      
      default:
        return (
          <TextField 
            {...field} 
            size='small'
            variant='standard'
            label='Value'
            InputProps={{
              inputProps: {
                style: {
                  height: '1.2rem',  
                  fontSize: '0.75rem',                        
                },
              },
            }}  
            InputLabelProps={{
                style: {
                    fontSize: '0.75em'
                }
            }}  
          />
        );
    }
  };

  const getOperators = (columnType) => {
    switch(columnType) {
      case 'range':
        return [
          { value: 'between', label: 'Between' }
        ];
      case 'multiselect':
        return [
          { value: 'in', label: 'Contains Any' },
          // { value: 'not_in', label: 'Does Not Contain' }
        ];
      case 'select':
        return [
          { value: 'equals', label: 'Is' },
          // { value: 'not_equals', label: 'Is Not' }
        ];
      case 'email':
        return [
          { value: 'equals', label: 'Equals' },
          // { value: 'contains', label: 'Contains' }
        ];
      case 'number':
        return [
          { value: 'equals', label: 'Equals' },
          { value: 'greaterThan', label: 'Greater Than' },
          // { value: 'lessThan', label: 'Less Than' },
          // { value: 'between', label: 'Between' }
        ];
      case 'date':
        return [
          { value: 'equals', label: 'Equals' },
          { value: 'lessThan', label: 'Before' },
          { value: 'greaterThan', label: 'After' },
          { value: 'between', label: 'Between' }
        ];
      case 'text':
      default:
        return [
          { value: 'contains', label: 'Contains' },
          { value: 'equals', label: 'Equals' },
          // { value: 'starts_with', label: 'Starts With' },
          // { value: 'ends_with', label: 'Ends With' }
        ];
    }
  };

  // const handleApplyFilter = (data) => {
  //   const transformedFilterOptions = data.filterOption.map(option => {
  //     if (option.fieldName && filterableColumns.find(col => col.key === option.fieldName)?.type === 'date') {
  //       if (option.operator === 'between') {
  //         return {
  //           ...option,
  //           value: option.value ? dayjs(option.value).toISOString() : null,
  //           endValue: option.endValue ? dayjs(option.endValue).toISOString() : null
  //         };
  //       }
  //       return {
  //         ...option,
  //         value: option.value ? dayjs(option.value).toISOString() : null
  //       };
  //     }
  //     return option;
  //   });

  //   setAnchorEl(null);
  //   onApplyFilter({ 
  //     ...data, 
  //     filterOption: transformedFilterOptions,
  //     locationFilters: data.locationFilters
  //   });
  // };

  const handleApplyFilter = (data) => {
    // Filter out invalid filter options - only include complete ones
    const validFilterOptions = data.filterOption.filter(option => {
        // Check if all required fields are present and valid
        const hasFieldName = option.fieldName && option.fieldName.trim() !== '';
        const hasOperator = option.operator && option.operator.trim() !== '';
        let hasValidValue = false;
        
        // Check value based on type
        if (option.value !== null && option.value !== undefined) {
            if (typeof option.value === 'string') {
                hasValidValue = option.value.trim() !== '';
            } else if (Array.isArray(option.value)) {
                hasValidValue = option.value.length > 0;
            } else {
                hasValidValue = true; // For numbers, booleans, dates etc.
            }
        }
        
        return hasFieldName && hasOperator && hasValidValue;
    });

    // Transform valid filter options (for dates)
    const transformedFilterOptions = validFilterOptions.map(option => {
      if (option.fieldName && filterableColumns.find(col => col.key === option.fieldName)?.type === 'date') {
        if (option.operator === 'between') {
          return {
            ...option,
            value: option.value ? dayjs(option.value).toISOString() : null,
            endValue: option.endValue ? dayjs(option.endValue).toISOString() : null
          };
        }
        return {
          ...option,
          value: option.value ? dayjs(option.value).toISOString() : null
        };
      }
      return option;
    });

    setAnchorEl(null);
    
    // Always send the data, but with only valid filter options
    onApplyFilter({ 
      ...data, 
      filterOption: transformedFilterOptions, // Only valid filters
      locationFilters: data.locationFilters
    });
  };
  
  
  return (
    <>
      <Button
        onClick={handleClick}
        sx={{
          textTransform: 'none',
        }}
        startIcon={ 
        <Badge 
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.5rem',
              fontWeight: '600',
              minWidth: '0',
              height: 'auto',
              padding: '10% 17%',
              borderRadius: '50%'
            },
            width: 'fit-content'
          }}  
          badgeContent={activeBadgeContent} 
          color="primary"
          invisible={activeBadgeContent === 0}
        >
          <FilterList />
        </Badge>
        }
      >
        Filters
      </Button>
      <Popover
        open={openFilterForm}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: { 
            width: {xs:'100%', md:'70%', lg:'60%'},
            p: '0.5rem 1rem',
            maxHeight: '80vh',
            overflowY: 'auto'
          }
        }}
      >
        <FormProvider {...filterFormMethod}> 
          <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <Typography
              sx={{
                fontSize: '1rem',
                fontWeight: 500,
                mb: 1
              }}
            >
              Filter Options:
            </Typography>
            {activeBadgeContent > 1 && (
              <Button 
                size='small' 
                onClick={() => {
                  reset();
                  onRemoveAllFIlters();
                }}
                startIcon={<DeleteForever/>}
              >
                Remove all
              </Button>
            )}
          </Box>

          <Box component={'form'} onSubmit={handleSubmit(handleApplyFilter)}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
              Basic Filters
            </Typography>
            
            {fields.map((field, index) => (
              <Grid container spacing={1} key={field.id} sx={{ mb: 1 }}>
                {index === 0 ? (
                  <>
                    {fields.length > 1 && <Grid item xs={2}/>}
                    <Grid item xs={3}>
                      <Controller
                        name={`filterOption.${index}.fieldName`}
                        control={control}
                        render={({ field: columnField }) => (
                          <FormControl variant='standard' sx={{ width:'100%' }} size="small">
                            <InputLabel id={`column-select-label-${index}`} sx={{fontSize:'.75em', lineHeight:'2em'}}>
                              Column
                            </InputLabel>
                            <Select
                              {...columnField}
                              labelId={`column-select-label-${index}`}
                              value={columnField.value || ''}
                              onChange={(e) => handleColumnChange(e, index, columnField)}
                              sx={{
                                minHeight: '0px',
                                height: '1.6rem',
                                fontSize: '0.75rem',
                                fontWeight: '600',
                                textTransform:'capitalize'
                              }}
                            >
                              {getAvailableColumns(index).map((column) => (
                                <MenuItem key={column.key} value={column.key} sx={{textTransform:'capitalize',fontSize:'0.75rem'}}>
                                  {column.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Controller
                        name={`filterOption.${index}.operator`}
                        control={control}
                        defaultValue='contains'
                        render={({ field: operatorField }) => {
                          const selectedColumn = filterableColumns.find(
                            col => col.key === filterOption[index]?.fieldName
                          );
                          const operators = getOperators(selectedColumn?.type || 'text');

                          return (
                            <FormControl variant='standard' sx={{ width:'100%' }} size="small">
                              <InputLabel id={`operator-select-label-${index}`} sx={{fontSize:'.75em', lineHeight:'2em'}}>
                                Operator
                              </InputLabel>
                              <Select
                                {...operatorField}
                                labelId={`operator-select-label-${index}`}
                                value={operatorField.value || 'contains'}
                                sx={{
                                  minHeight: '0px',
                                  height: '1.6rem',
                                  fontSize: '0.75rem',
                                  fontWeight: '600',
                                }}
                              >
                                {operators.map(op => (
                                  <MenuItem key={op.value} value={op.value} sx={{fontSize:'0.75rem'}}>
                                    {op.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          );
                        }}
                      />
                    </Grid>
                    <Grid item xs={fields.length === 1 ? 6 : 5}>
                      <Controller
                        name={`filterOption.${index}.value`}
                        control={control}
                        render={({ field: valueField }) => renderValueField(valueField, index)}
                      />
                    </Grid>
                    <Grid item xs={1} sx={{display:"flex", alignItems:'self-end'}}>
                      {fields.length === 1 && (
                        <IconButton 
                          size='small' 
                          sx={{p:0}}
                          onClick={() => {
                            setValue(`filterOption.${index}.fieldName`, '');
                            setValue(`filterOption.${index}.value`, null);
                          }}
                        >
                          <Close/>
                        </IconButton>
                      )}
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={2}>
                      <Controller
                        name={`filterOption.${index}.andOr`}
                        control={control}
                        defaultValue='and'
                        render={({ field: logicField }) => (
                          <FormControl variant='standard' sx={{ width:'100%' }} size="small">
                            <InputLabel id={`logic-select-label-${index}`} sx={{fontSize:'.75em', lineHeight:'2em'}}>
                              Logic
                            </InputLabel>
                            <Select
                              {...logicField}
                              labelId={`logic-select-label-${index}`}
                              value={logicField.value || 'and'}
                              sx={{
                                minHeight: '0px',
                                fontSize: '0.75rem',
                                fontWeight: '600',
                                height:'1.6rem'
                              }}
                            >
                              <MenuItem value="and" sx={{fontSize:'0.75rem'}}>AND</MenuItem>
                              <MenuItem value="or" sx={{fontSize:'0.75rem'}}>OR</MenuItem>
                            </Select>
                          </FormControl>
                        )}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Controller
                        name={`filterOption.${index}.fieldName`}
                        control={control}
                        render={({ field: columnField }) => (
                          <FormControl variant='standard' sx={{ width:'100%' }} size="small">
                            <InputLabel id={`column-select-label-${index}`} sx={{fontSize:'.75em', lineHeight:'2em'}}>
                              Column
                            </InputLabel>
                            <Select
                              {...columnField}
                              labelId={`column-select-label-${index}`}
                              value={columnField.value || ''}
                              onChange={(e) => handleColumnChange(e, index, columnField)}
                              sx={{
                                minHeight: '0px',
                                height: '1.6rem',
                                fontSize: '0.75rem',
                                fontWeight: '600',
                              }}
                            >
                              {getAvailableColumns(index).map((column) => (
                                <MenuItem key={column.key} value={column.key} sx={{textTransform:'capitalize',fontSize:'0.75rem'}}>
                                  {column.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Controller
                        name={`filterOption.${index}.operator`}
                        control={control}
                        defaultValue='contains'
                        render={({ field: operatorField }) => {
                          const selectedColumn = filterableColumns.find(
                            col => col.key === filterOption[index]?.fieldName
                          );
                          const operators = getOperators(selectedColumn?.type || 'text');

                          return (
                            <FormControl variant='standard' sx={{ width:'100%' }} size="small">
                              <InputLabel id={`operator-select-label-${index}`} sx={{fontSize:'.75em', lineHeight:'2em'}}>
                                Operator
                              </InputLabel>
                              <Select
                                {...operatorField}
                                labelId={`operator-select-label-${index}`}
                                value={operatorField.value || 'contains'}
                                sx={{
                                  minHeight: '0px',
                                  height: '1.6rem',
                                  fontSize: '0.75rem',
                                  fontWeight: '600',
                                }}
                              >
                                {operators.map(op => (
                                  <MenuItem key={op.value} value={op.value} sx={{fontSize:'0.75rem'}}>
                                    {op.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          );
                        }}
                      />
                    </Grid>
                    <Grid item xs={4.5}>
                      <Controller
                        name={`filterOption.${index}.value`}
                        control={control}
                        render={({ field: valueField }) => renderValueField(valueField, index)}
                      />
                    </Grid>
                    <Grid item xs={.5} sx={{display:"flex", alignItems:'self-end'}}>
                      <IconButton 
                        size='small' 
                        onClick={() => remove(index)} 
                        sx={{p:0,fontSize:'0.75rem'}}
                        color='error'
                      >
                        <Close sx={{fontSize:'1rem'}} />
                      </IconButton>
                    </Grid>
                  </>
                )}
              </Grid>
            ))}

            <Button 
              size='small'
              disabled={fields.length === filterableColumns.length} 
              onClick={() => append({ 
                fieldName: '', 
                operator: 'contains', 
                value: '', 
                andOr: 'and' 
              })} 
              startIcon={<Add/>}
              sx={{ mb: 2 }}
            >
              Add Filter
            </Button>

            {/* Enhanced Location Filters Section */}
            {enableLocationFilters && (
              <>
                <Divider sx={{ my: 2 }} />
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <LocationOn fontSize="small" />
                  {audienceType == 'customer' ? 'Location Filters' : 'Service Area Filters'}
                </Typography>
                
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Controller
                      name="locationFilters.locationFilter"
                      control={control}
                      render={({ field }) => (
                        <FormControl fullWidth sx={{ mb: 2 }}>
                          <FormLabel sx={{ fontSize: '0.85rem', fontWeight: 600, mb: 1 }}>Filter Type</FormLabel>
                          <RadioGroup
                            {...field}
                            value={field.value || 'radius'}
                          >
                            <FormControlLabel 
                              value="radius" 
                              control={<Radio size="small" />} 
                              label={<Typography sx={{ fontSize: '0.75rem' }}>Within Radius</Typography>} 
                            />
                            {enableGeoFilters && 
                              <FormControlLabel 
                                value="polygon" 
                                control={<Radio size="small" />} 
                                label={<Typography sx={{ fontSize: '0.75rem' }}>Geo Polygon</Typography>} 
                              />
                            }
                          </RadioGroup>
                        </FormControl>
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} md={8}>
                    {locationFilters?.locationFilter === 'radius' && (
                      <Box>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <Controller
                              name="locationFilters.centerCoordinates.lat"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  size="small"
                                  label="Center Latitude"
                                  type="number"
                                  variant="standard"
                                  InputProps={{
                                    style: { fontSize: '0.75rem' },
                                    inputProps: { step: 'any', min: -90, max: 90 }
                                  }}
                                  InputLabelProps={{
                                    style: { fontSize: '0.75em' }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Controller
                              name="locationFilters.centerCoordinates.lng"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  size="small"
                                  label="Center Longitude"
                                  type="number"
                                  variant="standard"
                                  InputProps={{
                                    style: { fontSize: '0.75rem' },
                                    inputProps: { step: 'any', min: -180, max: 180 }
                                  }}
                                  InputLabelProps={{
                                    style: { fontSize: '0.75em' }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Controller
                              name="locationFilters.radius"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  size="small"
                                  label="Radius (km)"
                                  type="number"
                                  variant="standard"
                                  InputProps={{
                                    style: { fontSize: '0.75rem' },
                                    inputProps: { min: 0.1, step: 0.1 }
                                  }}
                                  InputLabelProps={{
                                    style: { fontSize: '0.75em' }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    )}

                    {locationFilters?.locationFilter === 'polygon' && (
                      // <Alert severity="info" sx={{ fontSize: '0.75rem' }}>
                      //   Geo Polygon filtering will be implemented in future updates.
                      // </Alert>
                      <Box>
                        <Typography variant="body2" sx={{ fontSize: '0.75rem', mb: 2, color: 'text.secondary' }}>
                          Select predefined areas for targeted location filtering
                        </Typography>
                        <Controller
                          name="locationFilters.selectedPolygons"
                          control={control}
                          render={({ field }) => (
                            <Autocomplete
                              {...field}
                              multiple
                              size="small"
                              options={sampleGeoPolygons}
                              getOptionLabel={(option) => option.name}
                              value={field.value || []}
                              onChange={(event, newValue) => {
                                // Ensure uniqueness by filtering out duplicates based on polygon id
                                const uniqueValues = newValue.filter((polygon, index, self) => 
                                  index === self.findIndex(p => p.id === polygon.id)
                                );
                                
                                field.onChange(uniqueValues);
                                const coordinates = uniqueValues.map(polygon => polygon.coordinates);
                                setValue('locationFilters.polygon', coordinates);
                              }}
                              // Prevent selection of already selected options
                              getOptionDisabled={(option) => {
                                const currentValues = field.value || [];
                                return currentValues.some(selectedPolygon => selectedPolygon.id === option.id);
                              }}
                              // Ensure proper comparison for selected state
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                    variant="outlined"
                                    label={option.name}
                                    size="small"
                                    {...getTagProps({ index })}
                                    sx={{ fontSize: '0.65rem', height: '24px' }}
                                    key={option.id} // Add key for better React rendering
                                  />
                                ))
                              }
                              renderOption={(props, option) => {
                                // Check if option is already selected to show visual feedback
                                const isSelected = (field.value || []).some(selected => selected.id === option.id);
                                
                                return (
                                  <Box 
                                    component="li" 
                                    {...props}
                                    sx={{
                                      ...props.sx,
                                      opacity: isSelected ? 0.5 : 1,
                                      backgroundColor: isSelected ? 'action.selected' : 'transparent'
                                    }}
                                  >
                                    <Box sx={{ width: '100%' }}>
                                      <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 600 }}>
                                        {option.name} {isSelected && '(Selected)'}
                                      </Typography>
                                      <Typography variant="caption" sx={{ fontSize: '0.7rem', color: 'text.secondary' }}>
                                        {option.description}
                                      </Typography>
                                      {/* <Box sx={{ display: 'flex', gap: 2, mt: 0.5 }}>
                                        <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'primary.main' }}>
                                          Area: {option.area}
                                        </Typography>
                                        <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'success.main' }}>
                                          ~{option.estimatedUsers} users
                                        </Typography>
                                      </Box> */}
                                    </Box>
                                  </Box>
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  label="Select Geo Areas"
                                  placeholder="Choose predefined areas..."
                                  InputProps={{
                                    ...params.InputProps,
                                    style: {
                                      fontSize: '0.75rem',
                                      minHeight: '1.6rem'
                                    }
                                  }}
                                  InputLabelProps={{
                                    style: {
                                      fontSize: '0.75em'
                                    }
                                  }}
                                />
                              )}
                              sx={{ mb: 2 }}
                            />
                          )}
                        />
                        
                        {/* {locationFilters?.selectedPolygons && locationFilters.selectedPolygons.length > 0 && (
                          <Card variant="outlined" sx={{ mt: 2, p: 1 }}>
                            <Typography variant="subtitle2" sx={{ fontSize: '0.75rem', fontWeight: 600, mb: 1 }}>
                              Selected Areas:
                            </Typography>
                            <List dense sx={{ py: 0 }}>
                              {locationFilters.selectedPolygons.map((polygon, index) => (
                                <ListItem key={polygon.id} sx={{ py: 0.5, px: 1 }}>
                                  <ListItemText
                                    primary={polygon.name}
                                    secondary={`${polygon.area} • ~${polygon.estimatedUsers} users`}
                                    primaryTypographyProps={{ fontSize: '0.7rem', fontWeight: 600 }}
                                    secondaryTypographyProps={{ fontSize: '0.65rem' }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                            <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'text.secondary', mt: 1, display: 'block' }}>
                              Total estimated reach: {locationFilters.selectedPolygons.reduce((sum, polygon) => 
                                sum + parseInt(polygon.estimatedUsers.replace(/,/g, '')), 0
                              ).toLocaleString()} users
                            </Typography>
                          </Card>
                        )} */}
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </>
            )}

            <Box sx={{display:'flex', justifyContent:'flex-end', mt: 2}}>
              <Button 
                size='small' 
                type="submit"
                variant="contained"
                disabled={activeBadgeContent === 0}
              >
                Apply Filters
              </Button>
            </Box>
          </Box>
        </FormProvider>
      </Popover>
    </>
  );
};

export default AudienceFilter;